import styled from 'styled-components';

import { spacing, Label, fontSizes, fontWeights } from 'ui/theme';

export const ToggleSectionWrapper = styled.div`
  margin-bottom: ${spacing.base};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
`;

export const ToggleContentWrapper = styled.div`
  flex: 1 1 auto;
  margin-left: ${spacing.half};
`;

export const ToggleDetails = styled.div`
  margin-top: ${spacing.threeQuarter};
  margin-bottom: ${spacing.base};
  margin-left: ${spacing.plusHalf};
`;

export const CheckboxLabel = styled(Label)`
  font-weight: ${fontWeights.regular};
  line-height: ${fontSizes.s16};
  margin-left: ${spacing.quarter};
  margin-bottom: 0;
`;

export const CheckboxWrapper = styled.div<{ isDisabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
`;
